import { useMemo } from 'react';

import createAxios, { authInterceptor, handleAxiosResponse } from '@/lib/axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useFetcherWithToken(): <T>(...args: any) => Promise<T> {
  const fetcher = useMemo(() => {
    const coreClient = createAxios();
    coreClient.interceptors.request.use(authInterceptor);
    coreClient.interceptors.response.use(handleAxiosResponse);
    return coreClient;
  }, []);

  return fetcher;
}
